'use strict';

module.exports = function dd() {
  console.log(this.all());

  if (typeof process !== 'undefined') {
    process.exit(1);
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/collect.js/dist/methods/dd.js
// module id = 6J7G
// module chunks = 0